import {BlockSelector, ESD_BLOCK_IMAGE} from '../../constants/BlockName';
import {ImmutableHtmlNode} from '../../modifications/ImmutableNode';
import {BuiltInControl} from '../BuiltInControl';

export abstract class ImageBuiltInControl extends BuiltInControl {
  public getTargetNodes(root: ImmutableHtmlNode): ImmutableHtmlNode[] {
    const images = root.querySelectorAll(BlockSelector.IMAGE);
    const image = root.asElement().hasClass(ESD_BLOCK_IMAGE) ? [root] : [];
    return images.length ? images : image;
  }
}
